import React from 'react'
import styles from './Icons.scss'
import { Icon } from 'common/Icon'

const BASICS = [
  'premium-arrow', 'ios-arrow-up', 'ios-arrow-down', 'ios-arrow-back', 'ios-arrow-forward',
  'md-heart-outline', 'md-notifications', 'md-heart', 'ios-close-circle-outline', 'ios-close-circle',
  'md-menu', 'md-close', 'ios-more-rotated'
]

const ACTIONS = [
  'ios-cloud-upload-outline', 'ios-cloud-download-outline', 'ios-cloud-done-outline',
  'ios-cloud-upload', 'ios-cloud-download', 'ios-cloud-done', 'md-download', 'pin'
]
const LOGOS = [
  'logo-rwgps', 'logo-rwgps-simplified', 'logo-facebook', 'logo-twitter',
  'logo-instagram'
]

export const Icons = () => (
  <div className={styles.Icons}>
    <h1>Basics</h1>
    {section(BASICS)}
    <h1>Actions</h1>
    {section(ACTIONS)}
    <h1>Logos</h1>
    {section(LOGOS)}
  </div>
)

const section = c => (
  <div className={styles.grid}>
    {c.map(i => <GridItem key={i} i={i} />)}
  </div>
)

const GridItem = ({ i }) => (
  <div className={styles.GridItem}>
    <div>
      <Icon i={i} size={64} className={styles.icon} />
    </div>
    <p><Icon i={i} className={styles.icon} /> {i}</p>
  </div>
)
